/* © CNES */
import { CustomAccordion } from '../../../../shared/Accordion/CustomAccordion';
import { SliderValuesProps } from '../Filters';
import { InnerSlider } from './InnerSlider/InnerSlider';

/**
 * Slider Cloud Props.
 */
export interface GenericSliderProps {
  handleChange: (e: any, key: string) => void;
  sliderSection: {
    title: string;
    param: string;
    op: string;
  };
  sliderValues: SliderValuesProps;
  setSliderValues: (e: any) => void;
  sliderPosition: number;
}

/**
 * GenericSlider displays a filter section with slider.
 * @param handleChange handle change on slider values.
 * filterSectionName name of the filter section.
 * @returns GenericSlider Element.
 */
export const GenericSlider = ({
  handleChange,
  sliderSection,
  sliderValues,
  setSliderValues,
  sliderPosition,
}: GenericSliderProps) => {
  /**
   * set new values of cloud Cover.
   * @param value cloud Cover lower and upper value.
   */
  const onChangeSlider = (value: number[]) => {
    handleChange(value, sliderSection.param);
  };

  return (
    <div className="sliderFilter">
      <CustomAccordion
        title={sliderSection.title}
        children={
          <InnerSlider
            handleChange={onChangeSlider}
            sliderSectionParam={sliderSection.param}
            sliderValues={sliderValues}
            setSliderValues={setSliderValues}
            sliderPosition={sliderPosition}
          />
        }
      />
    </div>
  );
};
